import { FunctionComponent, useState, useEffect, DetailedHTMLProps, HTMLAttributes } from 'react';
import { Collapse } from '@material-ui/core';
import { useStyles } from './gift-card.styles';
import { RenderHtml } from '../render-html/render-html';
//import gogiftsvg from './go-gift.svg';
import gogiftpng from './go-gift.png';

type GiftCardProps = {
    // product type, eg. CAR, CONTENT, TRAVEL, etc.
    productType: string;
    amount: string;
    campaign?: string;
} & DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>;

const GiftCard: FunctionComponent<GiftCardProps> = (props): JSX.Element => {
    const classes = useStyles(props.campaign)();
    const [open, setOpen] = useState(false);
    const [labels, setLabels] = useState();
    const [didFetchLabels, setDidFetchLabels] = useState<boolean>(false);
    const [items, setItems] = useState<any>({
        expandedText: '',
        headerText: '',
        bodyText: '',
    });

    useEffect(() => {
        if (!didFetchLabels) {
            setDidFetchLabels(true);
            getLabels();
        }
    });

    useEffect(() => {
        if (labels) {
            setItems({
                expandedText: replaceVariables(labels['intro.expand']),
                headerText: replaceVariables(labels['intro.header']),
                bodyText: replaceVariables(labels['intro.text']),
            });
        }
    }, [labels]);

    const getLabels = async () => {
        const url = 'https://www.topdanmark.dk/rest/resourcebundle/giftcard/';
        const options = {
            Accept: 'application/json',
            method: 'GET',
        };

        try {
            const response = await fetch(url, options);
            const json = await response.json();
            setLabels(json);
        } catch (err) {
            // fail silently
        }
    };

    const replaceVariables = (inputVar: string) => {
        let outputVar = inputVar;
        const d = [
            ['{amount}', props.amount],
            ['{product}', labels && labels[`key.product.${props.productType}`]],
            ['{the_product}', labels && labels[`key.the_product.${props.productType}`]],
        ];

        if (outputVar) {
            d.forEach((el) => {
                outputVar = outputVar.split(el[0] || '').join(el[1]);
            });
        }

        return outputVar;
    };

    return (
        <div className={classes.parent}>
            <div className={classes.upperWrapper}>
                {props.campaign === 'blackweek' ? (
                    <img src={gogiftpng} width={70} style={{ paddingLeft: '20px' }} alt="GoGift Logo" />
                ) : (
                    <flos-icon shape="present" size="70" />
                )}
                <div className={classes.textbox}>
                    <div className="header">{items.headerText}</div>
                    <div className="text">{items.bodyText}</div>
                    {items.expandedText && (
                        <div className="details" onClick={() => setOpen(!open)}>
                            Detaljer&nbsp;&nbsp;
                            <flos-icon shape="arrow" dir="right" class={'arrow' + (open ? ' open' : ' closed')} />
                        </div>
                    )}
                </div>
            </div>
            {items.expandedText && (
                <Collapse in={open} classes={{ wrapperInner: classes.lowerWrapper }} collapsedSize={0}>
                    {/* <div className="leftBox">&nbsp;</div> */}
                    {/* <div className="rightBox"> */}
                    <RenderHtml html={items.expandedText} />
                    {/* </div> */}
                </Collapse>
            )}
        </div>
    );
};

export { GiftCard };
export type { GiftCardProps };
